import React from "react";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {UserCreateForm, UserEditForm} from "../UserForm";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";

export enum USER_MODAL_CONTENT {
  LOADING = 'loading',
  ADD = 'add',
  EDIT = 'edit',
  CONFIRM_DELETE = 'confirmDelete',
  MESSAGE = 'message',
}

export const UserModalContent = ({
  message,
  messageType,
  newUser,
  editedName,
  editedOrganizations,
  editedRole,
  editedPermissions,
  organizations,
  selectedRole,
  userRole,
  deletingUserId,
  handleChangeNewUser,
  handleChangeRole,
  handleChangeEditedName,
  handleChangeEditedOrganizations,
  handleChangeEditedRole,
  handleChangeEditedPermissions,
  handleUpdateUser,
  handleAddUser,
  handleDeleteUser,
  handleCloseDialog,
  handleClickOkButton
}) => ({
  [USER_MODAL_CONTENT.LOADING]: (
    <LoadingDialog label="載入中" />
  ),
  [USER_MODAL_CONTENT.ADD]: (
    <UserCreateForm
      newUser={newUser}
      organizations={organizations}
      selectedRole={selectedRole}
      userRole={userRole}
      onChangeNewUser={handleChangeNewUser}
      onChangeRole={handleChangeRole}
      handleAddUser={handleAddUser}
    />
  ),
  [USER_MODAL_CONTENT.EDIT]: (
    <UserEditForm
      editedName={editedName}
      editedOrganizations={editedOrganizations}
      editedRole={editedRole}
      editedPermissions={editedPermissions}
      userRole={userRole}
      organizations={organizations}
      onChangeEditedName={handleChangeEditedName}
      onChangeEditedOrganizations={handleChangeEditedOrganizations}
      onChangeEditedRole={handleChangeEditedRole}
      onChangeEditedPermissions={handleChangeEditedPermissions}
      handleUpdateUser={handleUpdateUser}
    />
  ),
  [USER_MODAL_CONTENT.CONFIRM_DELETE]: (
    <TwoButtonDialog
      type="warning"
      title="確定要刪除此帳號嗎? \n此動作將無法復原"
      leftLabel="不刪除"
      leftOnClick={handleCloseDialog}
      rightLabel="刪除"
      rightOnClick={() => handleDeleteUser(deletingUserId)}
      rightIconName="fa-trash"
      rightColor="warning"
    />
  ),
  [USER_MODAL_CONTENT.MESSAGE]: (
    <TwoButtonDialog
      type={messageType}
      title={message}
      leftLabel={"OK"}
      leftOnClick={handleClickOkButton}
      leftIconName="fa-check"
    />
  )
});
